import { Grid, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Item } from "./styledComponent";
import PrimaryButton from "../../../components/generic/buttons/PrimaryButton";
import { performPostRequest } from "../../../service/network/NetworkService";
import { getApiUrl } from "../../../service/network/UrlMapper";
import IntentType from "../../../intentexecutor/utils/IntentType";
import { notification } from "antd";
import ErrorNotificationComponent from "../../../components/generic/error/ErrorNotificationComponent";
import { publishEvent } from "../../../components/generic/EventPublisher";
import MemoryType from "../../../service/memory/enum/MemoryType";
import { useReadMemory } from "../../generic/hooks/useReadMemory";

const AddTitle = ({ theme, setTheme, organizationIdentifier }) => {
  const user = useReadMemory(MemoryType.USER)
  const [title, setTitle] = useState("");
  const [loading, setLoading] = useState(false);

  const handleClick = async (e) => {
    setLoading(true);
    e.preventDefault();
    const configurationValue = {
      ...theme,
      title,
    };

    const payload = {
      intent: "add_configuration",
      payload: {
        configurationKey: "niramaya.organization.theme",
        configurationValue: JSON.stringify(configurationValue),
      },
      context: {
        organizationIdentifier,
      },
    };

    try {
      const response = await performPostRequest(
        getApiUrl()[IntentType.ADD_CONFIGURATION],
        JSON.stringify(payload)
      );
      const result = await response.json();
      const themeValue = JSON.parse(result?.configurationValue || "{}");
      setTheme(themeValue);
      publishEvent("niramaya.organization.title.updated", user, themeValue, theme)
      notification.success({
        message: "Title updated successfully!",
        placement: "bottomRight",
      });
    } catch (error) {
      ErrorNotificationComponent(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setTitle(theme?.title);
  }, [theme?.title]);

  return (
    <>
      <Grid container spacing={2} sx={{ paddingBlock: 2 }}>
        <Grid xs={12} item>
          <Item elevation={0}>
            <h6 className="add-edit-patient-sub-header">Add Title</h6>
          </Item>
        </Grid>

        <Grid xs={12} item>
          <Item elevation={0}>
            <Grid container alignItems={"center"}>
              <Grid xs={9} sm={6} item>
                <TextField
                  id="title"
                  value={title}
                  fullWidth
                  label="Title"
                  variant="outlined"
                  onChange={(e) => setTitle(e.target.value)}
                />
              </Grid>
              <Grid xs={3} sm={6} item display={"flex"} justifyContent={"flex-end"}>
                <PrimaryButton
                  buttonText={"Add"}
                  handleOnClick={handleClick}
                  loading={loading}
                />
              </Grid>
            </Grid>
          </Item>
        </Grid>
      </Grid>
    </>
  );
};

export default AddTitle;
